import React, { useEffect, useState } from 'react';
import { formatNumberWithCommas, parseFormattedNumber } from 'shared/utils';

const sanitizeAmountInput = value => {
	const next = String(value).replace(/[^\d.]/g, '');
	const decimalIndex = next.indexOf('.');
	if (decimalIndex === -1) return next;
	return `${next.slice(0, decimalIndex + 1)}${next
		.slice(decimalIndex + 1)
		.replace(/\./g, '')}`;
};

export const CompensationAmountInput = ({ value, onChange }) => {
	const [displayValue, setDisplayValue] = useState(() =>
		formatNumberWithCommas(value)
	);
	const [isFocused, setIsFocused] = useState(false);

	useEffect(() => {
		if (!isFocused) {
			setDisplayValue(formatNumberWithCommas(value));
		}
	}, [value, isFocused]);

	return (
		<input
			className="input"
			type="text"
			inputMode="decimal"
			placeholder=" "
			value={displayValue}
			onFocus={() => setIsFocused(true)}
			onBlur={() => {
				setIsFocused(false);
				setDisplayValue(formatNumberWithCommas(value));
			}}
			onChange={e => {
				const sanitized = sanitizeAmountInput(e.target.value);
				setDisplayValue(formatNumberWithCommas(sanitized));
				onChange(parseFormattedNumber(sanitized));
			}}
		/>
	);
};
